import { Component, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DatepickerModalComponent } from '../datepicker-modal/datepicker-modal.component';
import { FlightPickerModalComponent } from '../flightpicker-modal/flightpicker-modal.component';
import { CommonModule, DatePipe } from '@angular/common';
import { set, addDays, addHours } from 'date-fns'
import { FormService } from '../organizations/features/booking/components/form/service';
import { ParkingRepo } from '../repo/parking.repo';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { TranslocoModule } from '@jsverse/transloco';
import { ParkingTimeOptions } from '../data/parking-time-options.enum';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, throwError } from 'rxjs';
import { BookingConfigService } from '../services/booking-config.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-datetimeflight-picker',
  imports: [
    DatePipe,
    MatMenuModule,
    TranslocoModule,
    CommonModule,
  ],
  providers: [],
  templateUrl: './datetimeflight-picker.component.html',
  styleUrl: './datetimeflight-picker.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    'style': 'font-family: Inter, sans-serif;'
  }
})

export class DateTimeFlightPickerComponent implements OnInit {

  selectedTime: string = "00:00";
  selectedDate: Date | null = null;
  selectedHotel: string = '';
  selectedHotelDisplay: string = '';
  selectedHotelDate: Date | null = null;
  selectedHotelTime: Date | null = null;
  selectedHotelLocation: string = '';
  selectedFlight: any;
  showHotel: boolean = false;
  parkingArrivalTimeText: string = '';
  ShuttleHotelTimeText: string = '';
  ShuttleAirportTimeText: string = '';
  @Input() searchData: any | null = null;
  hotelOptions: any = [];
  @Input({ required: true }) type: string = '';
  @ViewChild(MatMenuTrigger)
  timeMenuBtn!: MatMenuTrigger;
  arriveAtParkingOptions: any = [];
  site: string = '';
  hotelName: string = 'Quality Hotel Arlanda XPO';

  constructor(
    public dialog: MatDialog,
    private _formService: FormService,
    private _parkingRepo: ParkingRepo,
    private _datePipe: DatePipe,
    private http: HttpClient,
    private bookingConfigService: BookingConfigService,
    private snackBar: MatSnackBar
  ) {
    const config = this.bookingConfigService.getConfig();
    this.site = config.site;
  }

  combineDateTime(date: any, time: any): Date {
    time = time.split(":")
    const combinedDate = new Date(date);
    combinedDate.setHours(parseInt(time[0]));
    combinedDate.setMinutes(parseInt(time[1]));
    combinedDate.setSeconds(0);
    combinedDate.setMilliseconds(0);
    return combinedDate;
  }

  getFormattedDate(dateString: string) {
    let date = new Date(dateString);
    date.setHours(date.getHours() + 1); // Add one hour
    return this._datePipe.transform(date, 'yyyy-MM-dd HH:mm');
  }

  toggleHotel(event: any) {
    const isChecked = event.target.checked;
    this.showHotel = isChecked;
    if (this.type === 'arrival') {
      this._formService.getForm().get('search').controls.isArrivalHotel.setValue(isChecked);
      if (this.selectedHotelDate && this.selectedDate) {
        if (this.selectedHotelDate < this.selectedDate && isChecked) {
          this.selectedDate = null;
          this._formService.getForm().get('search').controls.arrivalDatetime.setValue(null);
        }
      }
    }
    if (this.type === 'departure') {
      this._formService.getForm().get('search').controls.isDepartureHotel.setValue(isChecked);
    }
    //  this.arriveAtParkingOptions = Object.values(ParkingTimeOptions).map(value => ({ value, viewValue: value }));
  }

  setHotel(hotel: any, viewValue: any, location: any, item: any) {
    this.selectedHotel = hotel;
    this.selectedHotelDisplay = viewValue;
    this.selectedHotelLocation = location;
    if (this.type === 'arrival') {
      this._formService.arrivalHotel = item;
      this._formService.getForm().get('hotels').controls.arrivalHotel.setValue(item)
    }
    if (this.type === 'departure') {
      this._formService.departureHotel = item;
      this._formService.getForm().get('hotels').controls.departureHotel.setValue(item)
    }
  }

  ngOnInit(): void {
    if (this.site === 'skavsta') {
      this.arriveAtParkingOptions = Object.values(ParkingTimeOptions).map(value => ({ value, viewValue: value }));
      let futureDate = addDays(new Date(), 5);
      this.selectedDate = this.type == 'departure' ? new Date() : futureDate
      if (this.type === 'arrival') {
        this.selectedFlight = this._formService.selectedArrivalFlight;
      }
      if (this.type === 'departure') {
        this.selectedFlight = this._formService.selectedDepartureFlight.getValue();
      }
      if (!this._formService.searchEndDate && !this._formService.searchEndDate) {
        if (this.type === 'arrival') {
          this._formService.searchEndDate = this.combineDateTime(futureDate, this.selectedTime);
        }
        if (this.type === 'departure') {
          this._formService.searchStartDate = this.combineDateTime(new Date(), this.selectedTime);
        }
      } else {
        if (this.type === 'arrival') {
          this.selectedDate = this._formService.searchEndDate
          this.selectedTime = this._formService.searchEndDate.getHours().toString().padStart(2, '0') + ':' + this._formService.searchEndDate.getMinutes().toString().padStart(2, '0')
        }
        if (this.type === 'departure') {
          this.selectedDate = this._formService.searchStartDate
          this.selectedTime = this._formService.searchStartDate.getHours().toString().padStart(2, '0') + ':' + this._formService.searchStartDate.getMinutes().toString().padStart(2, '0')
        }
      }
    }
    if (this.site === 'flygets' || this.site === 'tui' || this.site === 'nazar') {
      this.getHotelSelectOptions().subscribe({
        next: (hotelOptions: any) => {
          hotelOptions.map((option: any) => {
            this.hotelOptions.push({ value: option.terminalName, viewValue: option.terminalName })
          })
        }
      });
      if (this.type === 'arrival') {
        this._formService.getForm().get('search').controls.departureFlightDate.
          valueChanges.
          subscribe((value: any) => {
            if (this.selectedHotelDate) {
              if (value >= this.selectedHotelDate) {
                this.selectedHotelDate = null;
              }
            }
            if (this.selectedDate) {
              if (value >= this.selectedDate) {
                this.selectedDate = null;
              }
            }
          });

        this._formService.getForm().get('hotels').controls.departureDatetime.
          valueChanges.
          subscribe((value: any) => {
            if (this.selectedHotelDate) {
              if (value >= new Date(this.selectedHotelDate)) {
                this.selectedHotelDate = null;
              }
            }
            if (this.selectedDate) {
              if (value >= new Date(this.selectedDate)) {
                this.selectedDate = null;
                this.selectedFlight = null;
              }
            }
          });
      }

      if (this.searchData) {
        let hotels = this._formService.getForm().get('hotels');
        let flights = this._formService.getForm().get('flights');
        let search = this._formService.getForm().get('search');
        if (this.type === 'departure') {
          this.selectedDate = this.searchData?.flightDepartureDate || this.searchData?.departureDate || this.searchData?.departureFlightDate;
          this.selectedFlight = this.searchData?.departureFlight;
          if (this.selectedFlight) {
            this.arriveAtParkingOptions = this._parkingRepo.createParkingStartTimeOptions(this.selectedFlight.departureTime?.scheduled);
            this.setArrivedAtParking(this.arriveAtParkingOptions[6].value, this.arriveAtParkingOptions[6].viewValue, this.arriveAtParkingOptions[6].datetime);
          }
          this.selectedHotel = this.searchData?.departureHotel;
          this.selectedHotelDisplay = this.searchData?.departureHotel?.viewValue;
          this.selectedHotelDate = this.searchData?.hotelDepartureDate;
          if (this.selectedHotel && this.selectedHotelDate) {
            this.showHotel = true;
            search.controls.isDepartureHotel.setValue(true);
            this._formService.departureHotel = this.selectedHotel;
          }
          flights.controls.departureFlight.setValue(this.selectedFlight);
          hotels.controls.departureDatetime.setValue(this.selectedHotelDate);
          hotels.controls.departureHotel.setValue(this.selectedHotel);
          search.controls.departureFlightDate.setValue(this.selectedDate);
          this._formService.selectedDepartureFlight = this.selectedFlight
        }
        if (this.type === 'arrival') {
          this.selectedDate = this.searchData?.arrivalFlight?.arrivalTime?.scheduled || this.searchData?.arrivalDate || this.searchData?.arrivalFlightDate;
          this.selectedFlight = this.searchData?.arrivalFlight;
          this.selectedHotel = this.searchData?.arrivalHotel;
          this.selectedHotelDisplay = this.searchData?.arrivalHotel?.viewValue;
          this.selectedHotelDate = this.searchData?.hotelArrivalDate;
          if (this.selectedHotel && this.selectedHotelDate) {
            this.showHotel = true;
            search.controls.isArrivalHotel.setValue(true);
            this._formService.arrivalHotel = this.selectedHotel;

          }
          flights.controls.arrivalFlight.setValue(this.selectedFlight);
          search.controls.arrivalFlightDate.setValue(this.selectedDate);
          hotels.controls.arrivalDatetime.setValue(this.selectedHotelDate);
          hotels.controls.arrivalHotel.setValue(this.selectedHotel);
          this._formService.searchEndDate = this.selectedDate;
          this._formService.selectedArrivalFlight = this.selectedFlight
        }
      }
    }

    if (this.site === 'mdpark') {
      this.getHotelSelectOptions().subscribe({
        next: (hotelOptions: any) => {
          hotelOptions.map((option: any) => {
            this.hotelOptions.push({ value: option.terminalName, viewValue: option.terminalName })
          })
        }
      });
      if (this.type === 'arrival') {
        this._formService.getForm().get('search').controls.departureFlightDate.
          valueChanges.
          subscribe((value: any) => {
            if (this.selectedHotelDate) {
              if (value >= this.selectedHotelDate) {
                this.selectedHotelDate = null;
              }
            }
            if (this.selectedDate) {
              if (value >= this.selectedDate) {
                this.selectedDate = null;
              }
            }
          });

        this._formService.getForm().get('hotels').controls.departureDatetime.
          valueChanges.
          subscribe((value: any) => {
            if (this.selectedHotelDate) {
              if (value >= new Date(this.selectedHotelDate)) {
                this.selectedHotelDate = null;
              }
            }
            if (this.selectedDate) {
              if (value >= new Date(this.selectedDate)) {
                this.selectedDate = null;
                this.selectedFlight = null;
              }
            }
          });
      }

      if (this.searchData) {
        let hotels = this._formService.getForm().get('hotels');
        let flights = this._formService.getForm().get('flights');
        let search = this._formService.getForm().get('search');
        if (this.type === 'departure') {
          this.selectedDate = this.searchData?.flightDepartureDate;
          this.selectedFlight = this.searchData?.departureFlight;
          if (this.selectedFlight) {
            this.arriveAtParkingOptions = this._parkingRepo.createParkingStartTimeOptions(this.selectedFlight.departureTime?.scheduled);
            this.setArrivedAtParking(this.arriveAtParkingOptions[6].value, this.arriveAtParkingOptions[6].viewValue, this.arriveAtParkingOptions[6].datetime);
          }
          this.selectedHotel = this.searchData?.departureHotel;
          this.selectedHotelDisplay = this.searchData?.departureHotel?.viewValue;
          this.selectedHotelDate = this.searchData?.hotelDepartureDate;
          if (this.selectedHotel && this.selectedHotelDate) {
            this.showHotel = true;
            search.controls.isDepartureHotel.setValue(true);
            this._formService.departureHotel = this.selectedHotel;
          }
          flights.controls.departureFlight.setValue(this.selectedFlight);
          hotels.controls.departureDatetime.setValue(this.selectedHotelDate);
          hotels.controls.departureHotel.setValue(this.selectedHotel);
          search.controls.departureFlightDate.setValue(this.selectedDate);
          this._formService.selectedDepartureFlight = this.selectedFlight
        }
        if (this.type === 'arrival') {
          this.selectedDate = this.searchData?.arrivalFlight?.arrivalTime?.scheduled;
          this.selectedFlight = this.searchData?.arrivalFlight;
          this.selectedHotel = this.searchData?.arrivalHotel;
          this.selectedHotelDisplay = this.searchData?.arrivalHotel?.viewValue;
          this.selectedHotelDate = this.searchData?.hotelArrivalDate;
          if (this.selectedHotel && this.selectedHotelDate) {
            this.showHotel = true;
            search.controls.isArrivalHotel.setValue(true);
            this._formService.arrivalHotel = this.selectedHotel;
          }
          flights.controls.arrivalFlight.setValue(this.selectedFlight);
          search.controls.arrivalFlightDate.setValue(this.selectedDate);
          hotels.controls.arrivalDatetime.setValue(this.selectedHotelDate);
          hotels.controls.arrivalHotel.setValue(this.selectedHotel);
          this._formService.searchEndDate = this.selectedDate;
          this._formService.selectedArrivalFlight = this.selectedFlight
        }
      }
    }
  }

  getHotelSelectOptions() {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    let hostPath = JSON.parse(this.bookingConfigService.getConfig().IDENTITY);
    const URL = `${hostPath}Shuttlebuss/Shuttlebuss.Service/ArrivalDeparture/terminals/59D90114-9889-474E-A8A8-D1926F0DEE70`;
    return this.http
      .get<any>(URL, { headers })
      .pipe(map((hotelOptions: any) => {
        return hotelOptions
      }),
        catchError(
          this.handleError
        )
      );
  }

  private handleError(error: Response | any) {
    const errMsg = error.message
      ? error.message
      : error.status
        ? `${error.status} - ${error.statusText}`
        : 'Server error';
    console.error(`handleBookingService.handleError ${errMsg}`);
    return throwError(error);
  }

  openDateDialog(): void {
    const config = this.getDialogConfig(450);
    const dialogRef = this.dialog.open(DatepickerModalComponent, {
      maxWidth: '450px',
      width: '90%',
      position: config.position,
      height: config.height,
      data: {
        selectedDate: this.selectedDate,
        type: this.type,
        form: this._formService,
        isHotel: this.showHotel,
        hotelDate: this.selectedHotelDate
      }
    });

    dialogRef.componentInstance.dateSelectEvent.subscribe((date) => {
      this.selectedDate = date;
      this.selectedFlight = null;
      if (this.type === 'arrival') {
        this._formService.getForm().get('search').controls[this.type + 'Datetime'].setValue(this.selectedDate);
      }
      if (this.type === 'departure') {
        this._formService.getForm().get('search').controls.departureFlightDate.setValue(this.selectedDate);
        this._formService.searchStartDate = this.combineDateTime(this.selectedDate, this.selectedTime);
      }
    });
  }

  openHotelDateTimeDialog(): void {
    const config = this.getDialogConfig(455);
    const dialogRef = this.dialog.open(DatepickerModalComponent, {
      maxWidth: '450px',
      width: '90%',
      disableClose: true,
      position: config.position,
      height: config.height,
      data: {
        selectedDate: this.selectedHotelDate,
        type: this.type,
        timeSelector: true,
        form: this._formService
      }
    });

    dialogRef.componentInstance.dateSelectEvent.subscribe((date) => {
      if (this.selectedDate instanceof Date && date > this.selectedDate && this.type === 'departure') {
        this.selectedDate = null;
        this._formService.getForm().get('search').controls.departureFlightDate.setValue(null);
      }
      if (this.selectedDate instanceof Date && date < this.selectedDate && this.type === 'arrival') {
        this.selectedDate = null;
        this._formService.getForm().get('search').controls.arrivalDatetime.setValue(null);
      }
      if (this.selectedHotelDate instanceof Date) {

        this.selectedHotelDate = set(date, {

          hours: this.selectedHotelDate.getHours(),
          minutes: this.selectedHotelDate.getMinutes()
        })
      } else {
        this.selectedHotelDate = date
      }
      this._formService.getForm().get('hotels').controls[this.type + 'Datetime'].setValue(this.selectedHotelDate);
    });

    dialogRef.componentInstance.timeSelectEvent.subscribe((time) => {

      if (this.selectedHotelDate instanceof Date) {
        this.selectedHotelDate = set(this.selectedHotelDate, { hours: time.getHours(), minutes: time.getMinutes() });
      } else {
        this.selectedHotelDate = time;
      }
      this._formService.getForm().get('hotels').controls[this.type + 'Datetime'].setValue(this.selectedHotelDate);
    });
  }

  openFlightDialog() {
    if (!this.isFlightSelectEnabled) {
      return
    }
    const config = this.getDialogConfig(550);
    const dialogRef = this.dialog.open(FlightPickerModalComponent, {
      panelClass: 'pf-dateflight-picker-dialog',
      position: config.position,
      height: config.height,
      data: {
        selectedDate: this.selectedDate,
        type: this.type
      }
    });

    dialogRef.componentInstance.selectFlightEvent.subscribe((flight) => {
      this._formService.getForm().get('flights').controls[this.type + 'Flight'].setValue(flight);
      if (this.type === 'arrival') {
        this._formService.selectedArrivalFlight = flight;
        this.selectedFlight = flight
        let parkingEndDatetime = addHours(flight.arrivalTime?.scheduled, 1);
        this._formService.searchEndDate = parkingEndDatetime;
        this._formService.getForm().get('search').controls[this.type + 'Datetime']
          .setValue(this._formService.searchEndDate);
      }
      if (this.type === 'departure') {
        this._formService.selectedDepartureFlight = flight;
        this.selectedFlight = flight
        if (!this.showHotel) {
          this.arriveAtParkingOptions = this._parkingRepo.createParkingStartTimeOptions(flight.departureTime?.scheduled);
          this.setArrivedAtParking(this.arriveAtParkingOptions[6].value, this.arriveAtParkingOptions[6].viewValue, this.arriveAtParkingOptions[6].datetime);
        }
      }
    });

    dialogRef.componentInstance.flightTimeoutEvent.subscribe(() => {
      console.warn("Flight request timed out!");
      dialogRef.close();
      this.snackBar.open(
        'Misslyckades med att hämta data. Vänligen försök igen.',
        'OK',
        {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        }
      );
    });

    dialogRef.componentInstance.noInternetEvent.subscribe(() => {
      console.warn("Check the network connection!");
      dialogRef.close();
      this.snackBar.open(
        'Ingen internetanslutning. Kontrollera din nätverksanslutning.',
        'OK',
        { duration: 5000, verticalPosition: 'top', horizontalPosition: 'center' }
      );
    });

    dialogRef.componentInstance.errorEvent.subscribe(() => {
      console.warn("Something went wrong!");
      dialogRef.close();
      this.snackBar.open(
        'Något gick fel! Vänligen försök igen.',
        'OK',
        { duration: 5000, verticalPosition: 'top', horizontalPosition: 'center' }
      );
    });
  }

  get isFlightSelectEnabled(): boolean {
    if (this.selectedDate) {
      return true;
    }
    return false;
  }

  get isParkingArrivalTimeEnabled(): boolean {
    if (this.selectedFlight) {
      return true;
    }
    return false;
  }

  setArrivedAtParking(time: any, viewValue: any, dateTime: any) {
    this.selectedTime = time;
    this.parkingArrivalTimeText = viewValue;
    if (this.type === 'arrival') {
      this._formService.searchEndDate = dateTime;
    }
    if (this.type === 'departure') {
      this._formService.searchStartDate = dateTime;
      this._formService.getForm().get('search').controls[this.type + 'Datetime'].setValue(dateTime);
    }
  }

  openTimeDialog(): void {
    if (this.selectedFlight && !this.selectedHotel) {
      this.arriveAtParkingOptions = this._parkingRepo.createParkingStartTimeOptions(this.selectedFlight.departureTime?.scheduled);
    }
  }

  getDialogConfig(dialogHeight: number): { position: any, height: string } {
    let topPosition = undefined;
    let computedHeight = dialogHeight === 550 ? '550px' : 'auto';

    try {
      if (window.self !== window.top) {
        let iframeEl = window.frameElement as HTMLIFrameElement;
        if (!iframeEl) {
          const iframes = Array.from(window.parent.document.querySelectorAll('iframe'));
          iframeEl = iframes.find(iframe => iframe.contentWindow === window) as HTMLIFrameElement;
        }
        if (iframeEl) {
          const rect = iframeEl.getBoundingClientRect();
          const parentInnerHeight = window.parent.innerHeight;

          const targetHeight = Math.floor(parentInnerHeight * 0.95);

          if (dialogHeight === 550) {
            computedHeight = `${targetHeight}px`;
          } else {
            computedHeight = targetHeight < dialogHeight ? `${targetHeight}px` : 'auto';
          }

          const visibleTop = Math.max(0, -rect.top);
          const visibleBottom = Math.min(window.innerHeight, parentInnerHeight - rect.top);
          const centerY = visibleTop + (visibleBottom - visibleTop) / 2;

          const actualHeightNum = dialogHeight === 550 ? targetHeight : Math.min(dialogHeight, targetHeight);
          const topOffset = Math.max(10, centerY - (actualHeightNum / 2));
          topPosition = `${topOffset}px`;
        }
      }
    } catch (e) {
      console.warn('Could not calculate parent viewport positioning:', e);
    }

    return {
      position: topPosition ? { top: topPosition } : undefined,
      height: computedHeight
    };
  }

}
